module.exports = __webpack_public_path__ + "static/forecast/weather/nightmodsnow-bfc2054923a71a672b458f53d9ebb5c5.svg";